import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import {formatDate} from 'utils/datetime';

import Avatar from 'components/Avatar';
import Table from 'components/Table';
import Button from 'components/Button';
import Loading from 'components/Loading';
import {withFilters, FILTERS} from 'components/withFilters';

import {SearchInput} from 'containers/MyTeams/components/shared';
import {fetchAllTeams} from 'ducks/teams';

import './styles.css';

const initialFilters = {
  search: ''
};

const MemberIconsRow = ({members}) => (
  <div className="memberIconsRow">
    {members.length === 0 && (
      <div style={{textAlign: 'center'}}>This team has no members</div>
    )}
    {members.length > 0 &&
      members.slice(0, 10).map(member => (
        <div className="iconWrapper" key={member.id}>
          <Avatar
            url={member.internalAvatarCropped || member.avatarCropped}
            initials={member.initials}
          />
        </div>
      ))}
    {members.length > 10 && (
      <div className="iconWrapper">
        <div className="icon restMembersCount">+{members.length - 10}</div>
      </div>
    )}
  </div>
);

class AllTeamsTable extends React.Component<any> {
  onSearchChange = event => {
    const {target: {value}} = event;
    this.props.setFilter('search', value);
    this.fetchAll();
  };

  fetchAll = _.debounce(this.props.fetchAllTeams, 200);

  render() {
    const {
      teams,
      openAddTeamModal,
      openTeamDetailsModal,
      isLoading
    } = this.props;

    return (
      <div className="AllTeamsTable">
        <div className="header">
          <div className="heading">All teams</div>
          <SearchInput
            placeholder="Search for teams"
            onSearchChange={this.onSearchChange}
          />
        </div>
        <div className="tableContainer">
          {isLoading && <Loading />}
          {!isLoading && (
            <React.Fragment>
              <div className="tableHeader">
                <Table>
                  <Table.Header>
                    <Table.HeaderItem className="name" heading="name" />
                    <Table.HeaderItem className="members" heading="members" />
                    <Table.HeaderItem className="updated" heading="updated" />
                    <Table.HeaderItem className="created" heading="created" />
                  </Table.Header>
                </Table>
              </div>
              <div className="tableBody">
                <Table>
                  <Table.Body>
                    {teams.length > 0 &&
                      teams.map(team => (
                        <Table.Row
                          key={team.id}
                          onClick={() =>
                            openTeamDetailsModal({teamId: team.id})
                          }>
                          <Table.Cell className="name">
                            <div className="teamInfo">
                              <Avatar url={team.avatar} initials="" />
                              <div className="teamInfo">{team.name}</div>
                            </div>
                          </Table.Cell>
                          <Table.Cell className="members">
                            <MemberIconsRow members={team.members} />
                          </Table.Cell>
                          <Table.Cell className="updated">
                            {formatDate(team.updatedAt)}
                          </Table.Cell>
                          <Table.Cell className="created">
                            {formatDate(team.createdAt)}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    {teams.length === 0 && (
                      <Table.Row>
                        <Table.Cell colSpan="4">
                          <div style={{textAlign: 'center'}}>
                            Teams list is empty
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </Table.Body>
                </Table>
              </div>
            </React.Fragment>
          )}
        </div>
        <div className="footer">
          <Button onClick={openAddTeamModal} white>
            Add new
          </Button>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = {
  fetchAllTeams
};

export default connect(null, mapDispatchToProps)(
  withFilters(AllTeamsTable, FILTERS.MY_TEAMS_TEAMS, {
    initialFilters
  })
);
